import TicketIcon from './TicketIcon';

export default TicketIcon;
